// chemoAdministrationSchema.js
import * as Yup from "yup";

export const chemoAdministrationSchema = Yup.object().shape({
    doctorName: Yup.string()
        .required("Doctor name is required"),

    // All other fields are optional (free hand)
});